'use client';
import { SignupForm } from "@/components/custom/signup-form";
import Image from "next/image";
import Link from "next/link";


export default function SignupPage() {
    return (
        <div className="h-screen bg-gradient-to-br from-background via-background to-muted flex">
            {/* Logo in top left corner */}
            <Link href="/" className="absolute top-4 left-4 z-50">
                <Image
                    src="/images/18logo.png"
                    alt="18Bricks Logo"
                    width={60}
                    height={60}
                    className="cursor-pointer hover:opacity-80 transition-opacity"
                />
            </Link>

            <div className="w-full grid md:grid-cols-2">
                <div className="hidden lg:flex flex-1 relative min-h-screen">
                    {/* Background with Dubai cityscape */}
                    <div className="absolute inset-0">
                        <Image
                            src="https://images.pexels.com/photos/325193/pexels-photo-325193.jpeg"
                            alt="Dubai Skyline"
                            fill
                            className="object-cover"
                            priority
                        />
                        {/* Gradient overlay for better text readability */}
                        <div className="absolute inset-0 bg-gradient-to-r from-black/40 to-black/20"></div>
                    </div>

                    {/* Content overlay */}
                    <div className="relative z-10 p-12 flex flex-col justify-center">
                        <div className="text-left">
                            <h2 className="text-4xl font-bold text-white mb-4">Join Dubai Properties</h2>
                            <p className="text-lg text-white/90 mb-8">
                                Create your account and start exploring luxury properties in Dubai&apos;s most prestigious locations
                            </p>
                        </div>

                        <div className="flex items-center gap-4 text-sm text-white/80 mt-16">
                            <div className="flex items-center gap-2">
                                <div className="w-2 h-2 bg-primary rounded-full"></div>
                                <span>Premium Locations</span>
                            </div>
                            <div className="flex items-center gap-2">
                                <div className="w-2 h-2 bg-accent rounded-full"></div>
                                <span>Luxury Properties</span>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="w-full lg:w-2xl lg:mx-auto lg:flex-shrink-0 flex flex-col justify-center p-8 lg:p-12">
                    <div className="text-center mb-8">
                        <div className="inline-flex items-center justify-center w-16 h-16 bg-primary rounded-xl mb-4">
                            <svg className="w-8 h-8 text-primary-foreground" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    strokeWidth={2}
                                    d="M18 9v3m0 0v3m0-3h3m-3 0h-3m-2-5a4 4 0 11-8 0 4 4 0 018 0zM3 20a6 6 0 0112 0v1H3v-1z"
                                />
                            </svg>
                        </div>
                        <h1 className="text-3xl font-bold text-foreground mb-2">Create Account</h1>
                        <p className="text-muted-foreground">Sign up to access exclusive property listings</p>
                    </div>

                    <SignupForm />

                    <div className="text-center mt-6">
                        <p className="text-sm text-muted-foreground">
                            Already have an account?{" "}
                            <Link href="/login" className="text-primary hover:underline hover:text-primary/80 font-medium transition-colors">
                                Sign in
                            </Link>
                        </p>
                    </div>
                </div>
            </div>
        </div>
    )
}